// extracted by mini-css-extract-plugin
export default {"errorLabel":"newProduct_errorLabel__JusVj","buttonDiv":"newProduct_buttonDiv__Bl6a9"};